export default "__VITE_ASSET__BrKYKWtl__"